import { render, staticRenderFns } from "./EmployeesImport.vue?vue&type=template&id=364b074f"
import script from "./EmployeesImport.vue?vue&type=script&lang=js"
export * from "./EmployeesImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports